import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  background-color: #ededed;
  .left {
    width: 60%;
    height: 100%;
  }
  .right {
    flex: 1;
    background-color: #ffffff;
    position: relative;
  }
  @media screen and (max-width: 1240px) {
    height: calc(100vh - 40px);
    height: calc(100svh - 40px);
    .left {
      display: none;
    }
  }
`;
